import React, { Component } from "react";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { ModalBanner } from "../../assets";
import axios from "axios";
import { toast } from "react-toastify";
import BaseModal from "./baseModal/BaseModal";
import { CONTENT_BLOCK, STRING_INPUT } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
import { format } from "date-fns";

class ViewCouponModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProgramNames: "",
      isLoading: true
    };
    console.log("current state: ", props);
  }

  async componentDidMount() {
    await this.fetchCurrentProgramNames();
  }

  async fetchCurrentProgramNames() {
    try {
      let programArray = [
        ...this.props.couponInfo.programs_picked,
        ...this.props.couponInfo.online_picked,
        ...this.props.couponInfo.event_picked
      ];
      
      if (programArray.length === 0) {
        this.setState({ currentProgramNames: "All", isLoading: false });
        return;
      }

      let objArray = programArray.map(JSON.parse);
      let programIds = objArray.map(obj => obj.value.id);

      const ep = `${process.env.REACT_APP_API}/partners/programs/list`;
      const ep2 = `${process.env.REACT_APP_API}/partners/virtual/list`;
      const ep3 = `${process.env.REACT_APP_API}/partners/events/list`;
      
      const [programsRes, onlineRes, eventsRes] = await Promise.all([
        axios.get(ep),
        axios.get(ep2),
        axios.get(ep3)
      ]);

      if (programsRes.data.success && onlineRes.data.success && eventsRes.data.success) {
        const allPrograms = [
          ...programsRes.data.data,
          ...onlineRes.data.data,
          ...eventsRes.data.data
        ];

        const currentNames = programIds.map(id => {
          const program = allPrograms.find(p => p.id === id);
          return program ? (program.program_name || program.event_title) : `Program ID: ${id}`;
        });

        this.setState({
          currentProgramNames: currentNames.join(", "),
          isLoading: false
        });
      } else {
        let programNames = objArray.map(obj => obj.text).join(", ");
        this.setState({
          currentProgramNames: programNames,
          isLoading: false
        });
      }
    } catch (error) {
      console.error("Error fetching current program names:", error);
      let programArray = [
        ...this.props.couponInfo.programs_picked,
        ...this.props.couponInfo.online_picked,
        ...this.props.couponInfo.event_picked
      ];
      let objArray = programArray.map(JSON.parse);
      let programNames = objArray.map(obj => obj.text).join(", ");
      this.setState({
        currentProgramNames: programNames,
        isLoading: false
      });
    }
  }

  /// ================== NEW MODAL ========================== ///
  getBaseModalFields() {
    const fieldCouponCode = {
      type: CONTENT_BLOCK,
      data: {
        name: "Coupon Code",
        content: this.props.couponInfo.coupon_id
      }
    };

    const fieldInternalName = {
      type: CONTENT_BLOCK,
      data: {
        name: "Internal Name",
        content: this.props.couponInfo.coupon_name
      }
    };

    const fieldDiscountType = {
      type: CONTENT_BLOCK,
      data: {
        name: "Discount Type",
        content:
          this.props.couponInfo.type === "Amount"
            ? "Fixed Amount ($)"
            : "Percentage (%)"
      }
    };

    const fieldDiscountRate = {
      type: CONTENT_BLOCK,
      data: {
        name: "Discount Rate",
        content: this.props.couponInfo.amount_off
      }
    };

    const fieldPrograms = {
      type: CONTENT_BLOCK,
      data: {
        name: "Coupon Applied To:",
        content: this.state.isLoading ? "Loading..." : this.state.currentProgramNames
      }
    };

    const fieldRedemptionCount = {
      type: CONTENT_BLOCK,
      data: {
        name: "Redemption Count",
        content: this.props.couponInfo.redemption_count
      }
    };

    const fieldDuration = {
      type: CONTENT_BLOCK,
      data: {
        name: "Duration",
        content:
          this.props.couponInfo.duration.substring(0, 1).toUpperCase() +
          this.props.couponInfo.duration.substring(1)
      }
    };

    const fieldExpiryDate = {
      type: CONTENT_BLOCK,
      data: {
        name: "Expiry Date",
        content: this.props.couponInfo.redeem_by
          ? format(new Date(this.props.couponInfo.redeem_by), "LLLL dd, yyyy")
          : "Does not expiry"
      }
    };

    return [
      fieldCouponCode,
      fieldInternalName,
      fieldDiscountType,
      fieldDiscountRate,
      fieldPrograms,
      fieldRedemptionCount,
      fieldDuration,
      fieldExpiryDate
    ];
  }

  getBaseModalButtons = () => {
    const addButton = {
      name: "Close",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatorKey: "validateSubmit",
      handleClick: e => this.props.onClose()
    };

    return [addButton];
  };

  getBaseModalProps = () => {
    return {
      title: "View Coupon",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: this.props.onClose
    };
  };

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default ViewCouponModal;
